import styled from '@emotion/styled';

export const Container = styled.div`
  --dark-blue: #1f2d49;

  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 1000;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;

  * {
    font-size: 1rem;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    letter-spacing: 0.0864rem;
    line-height: normal;
  }

  .info-title {
    color: var(--dark-blue);
    font-weight: 500;
    letter-spacing: 0.096rem;
    margin-bottom: 1rem;
  }

  .info-text {
    color: #8b8b8b;
    font-size: 0.9rem;
    margin-bottom: 2.5rem;
    display: flex;
    gap: 0.25rem;
  }

  & > header {
    width: 100%;
    height: var(--header-height);
    background-color: var(--dark-blue);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: 1.5rem;

    & > .header__title {
      font-size: 1.2rem;
      color: #fff;
      letter-spacing: 0.1152rem;
    }

    & > .header__button {
      aspect-ratio: 1;
      width: 1.7rem;
      border: none;
      background-color: transparent;

      & > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  & > .content {
    background-color: #efefef;
    padding: 1.25rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow-y: auto;

    & > .content__title {
      color: var(--dark-blue);
      padding: 0 1.85rem 0.5rem;
      border-bottom: 0.15rem solid var(--dark-blue);
      margin-bottom: 0.82rem;
      line-height: normal;
    }

    & > .locker-info {
      width: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      box-shadow: 0 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.05);

      @media (orientation: landscape) {
        flex-direction: row;
      }

      & > .locker-info__img {
        width: 100%;
        height: 15.375rem;
        object-fit: cover;

        @media (orientation: landscape) {
          max-width: 30rem;
        }
      }

      & > .locker-info__content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3.25rem 1.5rem;

        @media (orientation: landscape) {
          min-width: fit-content;
        }

        & > .locker-info__button-group {
          width: 100%;
          display: flex;
          gap: 1rem;
        }
      }
    }
  }
`;
